module.exports = __webpack_public_path__ + "img/procura-banner-search-woman.52b1a8aa.webp";